module.exports = __webpack_public_path__ + "img/horizontal_7_5_8023.e036d808.png";